import { EThemeNames } from '@/constants';
import useBotConfig from '@/hooks/useBotConfig';
import { createContext, useState, ReactNode } from 'react';

type ThemeContextType = {
  botType: string;
  setBotType: (botType: string) => void;
};

export const ThemeContext = createContext<ThemeContextType>({
  botType: EThemeNames.TELEHEALTH_TRIAGE_BOT,
  setBotType: () => {
    return;
  },
});

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const { currentBotConfig } = useBotConfig();
  const themeName =
    currentBotConfig?.themeName || EThemeNames.TELEHEALTH_TRIAGE_BOT;
  const [botType, setBotType] = useState(themeName);

  return (
    <ThemeContext.Provider value={{ botType, setBotType }}>
      <div
        data-theme={botType}
        className="min-h-screen bg-background font-secondary"
      >
        {children}
      </div>
    </ThemeContext.Provider>
  );
};
